import customAxios from '../../customAxios';
import { PAY_OFFLINE } from '../../routes';

async function payOflineService(props: any) {

  let body: any = {
    fishId        : props.fishId        ,
    serviceId     : props.serviceId     ,
    payerType     : props.payerType     ,
    offlinePayType: props.offlinePayType,
  };

  try {
    return (await customAxios.post(PAY_OFFLINE, body)).data;
  } catch (error: any) {
    console.error({ PAY_OFFLINE: error });
  }
}

export default payOflineService;
